<template>
  <PreviewElementWrapper 
    :initial-selected="isSelected"
    :elementType="element.type" 
    :element="element" 
    :selectedPreviewId="selectedPreviewId"
    :disabled="disabled"
    @select-change="handleSelectChange"
    @update-element-data="$emit('update-element-data', $event)"
    @auto-mapping="$emit('auto-mapping', element.id)"
    @element-edit-state-changed="$emit('element-edit-state-changed', $event)"
  >
    <div class="options-container">
      <div class="option-item">
        <div class="radio-button">
          <div class="radio-outer"></div>
        </div>
        <span class="option-label">Yes</span>
      </div>
      <div class="option-item">
        <div class="radio-button">
          <div class="radio-outer"></div>
        </div>
        <span class="option-label">No</span>
      </div>
    </div>
  </PreviewElementWrapper>
</template>

<script>
import PreviewElementWrapper from './PreviewElementWrapper.vue';

export default {
  name: 'YesNoPreview',
  components: { PreviewElementWrapper },
  props: {
    element: { type: Object, default: () => ({}) },
    selectedPreviewId: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isSelected: false
    };
  },
  emits: [
    'update-element-data', 
    'auto-mapping', 
    'element-edit-state-changed'
  ],
  methods: {
    handleSelectChange(isSelected) {
      this.isSelected = isSelected;
    }
  }
};
</script>

<style scoped>
.options-container {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 0 64px;
}

.option-item {
  width: 50%;
  min-width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.radio-button {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}

.radio-outer {
  width: 20px;
  height: 20px;
  border: 2px solid #004879;
  border-radius: 50%;
  background: #fff;
}

.option-label {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #333;
}

</style>
